import type { JSX } from 'react';

import { useMediaHitsContext } from '../../shared/context';
import { LoadingSkeleton } from '../LoadingSkeleton';

import { MediaHit } from './components/MediaHit';

function renderLoadingSkeletons(mediaHitComments: Array<{ id: string }> | undefined): JSX.Element[] {
	return (
		mediaHitComments?.map(({ id }) => (
			<div
				key={id}
				className="w-[300px] shrink-0 snap-start scroll-ml-6 md:w-[500px] md:snap-align-none md:scroll-ml-0"
			>
				<LoadingSkeleton />
			</div>
		)) || []
	);
}

export function MediaHitList({ ref }: { ref?: React.RefObject<HTMLDivElement | null> }): JSX.Element | null {
	const {
		data: { mediaEmbeds, mediaHitComments, loadingAllEmbeds, loadingSingleEmbed },
		actions: { removeMedia },
	} = useMediaHitsContext();

	// Don't render if no content to show
	if (!(loadingAllEmbeds || loadingSingleEmbed) && mediaEmbeds.length === 0) {
		return null;
	}

	return (
		<div
			ref={ref}
			data-testid="media-hit-list"
			className="mt-[52px] box-border flex w-full max-w-full snap-x snap-mandatory flex-row flex-nowrap gap-4 overflow-x-auto scroll-smooth px-6 pb-[52px] md:snap-none md:scroll-auto md:px-8 md:pb-14"
		>
			{loadingSingleEmbed && (
				<div
					className="w-[300px] shrink-0 snap-start scroll-ml-6 md:w-[500px] md:snap-align-none md:scroll-ml-0"
					data-testid="media-hit-loading"
				>
					<LoadingSkeleton />
				</div>
			)}
			{loadingAllEmbeds && renderLoadingSkeletons(mediaHitComments)}
			{!loadingAllEmbeds &&
				mediaEmbeds.map((media) => <MediaHit key={media.id} media={media} removeMedia={removeMedia} />)}
		</div>
	);
}
